import pino from 'pino';

export type Logger = pino.Logger;

const level = process.env.CODERULE_LOG_LEVEL ?? 'info';

const baseLogger = pino(
  {
    level,
    name: 'coderule-scanner',
    timestamp: pino.stdTimeFunctions.isoTime,
  },
  process.stderr,
);

export const logger: Logger = baseLogger;

export function createLogger(scope: string): Logger {
  return baseLogger.child({ scope });
}
